// extracted by mini-css-extract-plugin
export var animationContainer = "_ih-0";
export var footer = "_ih-1";
export var gray = "_ih-2";
export var lineItem = "_ih-3";
export var lineItemImage = "_ih-4";
export var lineItemInfo = "_ih-5";
export var lineItemText = "_ih-6";
export var lineItems = "_ih-7";
export var modalContent = "_ih-8";
export var options = "_ih-9";
export var orderName = "_ih-a";
export var refundAmount = "_ih-b";